import axios from '@/core/http'

const publicationsTransferRequest = (src: string, dst: string) => {
  return axios.post('core/management/publications-transfer/', { src, dst })
}

export { publicationsTransferRequest }
